import { Link } from "react-router-dom";
import { Clock, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { COOKIE_SETTINGS_EVENT } from "./CookieConsentBanner";
import { trackPhoneClick, trackWhatsAppClick } from "../utils/analytics";

function Footer() {
  const openCookieSettings = () => {
    localStorage.removeItem("cookieConsent");
    window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
  };

  return (
    <footer className="border-t border-white/10 bg-black px-6 py-10">
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <h3 className="text-2xl font-bold text-yellow-400">
            Limassol Airport Taxi
          </h3>

          <p className="mt-4 leading-7 text-neutral-400">
            Reliable 24/7 airport transfers and taxi services across Cyprus.
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <a
              href="tel:+35796613191"
              onClick={() => trackPhoneClick("footer")}
              className="rounded-2xl bg-yellow-400 px-5 py-3 text-center font-bold text-black transition-colors duration-200 hover:bg-yellow-300"
            >
              Call Now
            </a>

            <a
              href="https://wa.me/35796613191?text=Hello,%20I%20would%20like%20to%20book%20a%20taxi."
              onClick={() => trackWhatsAppClick("footer")}
              target="_blank"
              rel="noreferrer"
              className="rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-3 text-center font-bold text-white transition-colors duration-200 hover:border-yellow-400/50 hover:text-yellow-300"
            >
              WhatsApp
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-bold text-yellow-400">Quick Links</h4>

          <ul className="mt-4 space-y-3 text-neutral-400">
            <li>
              <Link to="/" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Home
              </Link>
            </li>
            <li>
              <Link to="/cyprus" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Cyprus Guide
              </Link>
            </li>
            <li>
              <Link to="/things-to-do-in-limassol" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Things to Do in Limassol
              </Link>
            </li>
            <li>
              <Link to="/larnaca-airport-taxi" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Larnaca Airport Taxi
              </Link>
            </li>
            <li>
              <Link to="/paphos-airport-taxi" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Paphos Airport Taxi
              </Link>
            </li>
            <li>
              <Link to="/taxi-limassol" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Taxi Limassol
              </Link>
            </li>
            <li>
              <Link to="/cyprus-airport-transfers" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Cyprus Airport Transfers
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-and-conditions" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Terms &amp; Conditions
              </Link>
            </li>
            <li>
              <Link to="/cookie-policy" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Cookie Policy
              </Link>
            </li>
            <li>
              <Link to="/limassol-to-larnaca-airport-taxi" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Limassol to Larnaca Airport Taxi
              </Link>
            </li>
            <li>
              <Link to="/limassol-to-paphos-airport-taxi" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Limassol to Paphos Airport Taxi
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-yellow-400">Popular Routes</h4>

          <ul className="mt-4 space-y-3 text-neutral-400">
            <li>
              <Link to="/larnaca-airport-to-limassol" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Larnaca Airport → Limassol
              </Link>
            </li>
            <li>
              <Link to="/paphos-airport-to-limassol" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Paphos Airport → Limassol
              </Link>
            </li>
            <li>
              <Link to="/larnaca-airport-taxi" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Limassol → Larnaca Airport
              </Link>
            </li>
            <li>
              <Link to="/paphos-airport-taxi" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Limassol → Paphos Airport
              </Link>
            </li>
            <li>
              <Link to="/limassol-to-nicosia" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Limassol → Nicosia
              </Link>
            </li>
            <li>
              <Link to="/limassol-to-ayia-napa" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Limassol → Ayia Napa
              </Link>
            </li>
            <li>
              <Link to="/limassol-to-protaras" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Limassol → Protaras
              </Link>
            </li>
            <li>
              <Link to="/limassol-to-troodos" className="inline-block transition-colors duration-200 hover:translate-x-1 hover:text-yellow-300">
                Limassol → Troodos
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-yellow-400">Contact</h4>

          <ul className="mt-4 space-y-4 text-neutral-400">
            <li className="flex items-center gap-3">
              <Phone className="h-5 w-5 shrink-0 text-yellow-400" />
              <span>Phone: +357 96 613 191</span>
            </li>
            <li className="flex items-center gap-3">
              <MessageCircle className="h-5 w-5 shrink-0 text-yellow-400" />
              <span>WhatsApp: +357 96 613 191</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-5 w-5 shrink-0 text-yellow-400" />
              <a
                href="mailto:info@limassolairporttaxi.com"
                className="break-all transition-colors duration-200 hover:text-yellow-300"
              >
                info@limassolairporttaxi.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-5 w-5 shrink-0 text-yellow-400" />
              <span>Location: Limassol, Cyprus</span>
            </li>
            <li className="flex items-center gap-3">
              <Clock className="h-5 w-5 shrink-0 text-yellow-400" />
              <span>Available 24/7</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-7xl border-t border-white/10 pt-6 text-center text-sm leading-6 text-neutral-500">
        <p>© 2026 Limassol Airport Taxi. All rights reserved.</p>
        <p>Licensed Taxi & Airport Transfer Service in Cyprus.</p>
        <button
          type="button"
          onClick={openCookieSettings}
          className="mt-3 font-semibold text-yellow-400 transition hover:text-yellow-300"
        >
          Cookie Settings
        </button>
      </div>
    </footer>
  );
}

export default Footer;
